<template>
  <div class="container">
    <a class="button is-primary-ghost-small" @click="goBack">{{ backToByRouteNameTranslated[validPreviousState.name] }}</a>
  </div>
</template>

<script>

import RedirectsService from 'top20common/distribution/services/redirects';
import translated from 'top20common/distribution/services/translated-data';
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters(['validPreviousState']),
    backToByRouteNameTranslated() {
      return translated.backToByRouteNameTranslated(this);
    }
  },
  methods: {
    goBack() {
      this.$mam.trackBackToApplicationClicked(this.validPreviousState.name);
      window.location.href = RedirectsService.getUrlWithoutLanguage(this.validPreviousState.path);
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  position: initial;
  height: auto;
  .is-primary-ghost-small {
    width: initial;
    position: absolute;
    top: 22px;
    z-index: 1;
    right: 20px;
  }
}
</style>
